export const loansPtBr = {
  missingLoanId: 'Identificador do empréstimo não informado.',
  title: 'Empréstimos',
  description: 'Contratos de crédito sincronizados via Open Finance.',
  empty: 'Nenhum empréstimo encontrado. Conecte contas em Integrações para sincronizar.',
  connectAccounts: 'Ir para Integrações',
  hideValues: 'Ocultar valores',
  showValues: 'Mostrar valores',
  filters: {
    entity: 'Entidade',
    connection: 'Conexão',
    all: 'Todos',
    clearFilters: 'Limpar filtros',
    noResultsHint: 'Limpe os filtros para ver todos os contratos.',
  },
  summary: {
    totalContracts: 'Contratos',
    totalOutstanding: 'Saldo devedor total',
    activeContracts: 'Ativos',
    overdueContracts: 'Com parcelas vencidas',
  },
  groupedByType: 'Por tipo de operação',
  typeOther: 'Outros',
  card: {
    contract: 'Contrato',
    amount: 'Valor contratado',
    balance: 'Saldo devedor',
    due: 'Vencimento',
    cet: 'CET a.a.',
    status: 'Status',
  },
  status: {
    ACTIVE: 'Ativo',
    PENDING: 'Pendente',
    CLOSED: 'Encerrado',
  },
  types: {
    CREDITO_PESSOAL_SEM_CONSIGNACAO: 'Crédito pessoal sem consignação',
    CREDITO_PESSOAL_COM_CONSIGNACAO: 'Crédito pessoal com consignação',
    HOME_EQUITY: 'Home equity',
    MICROCREDITO_PRODUTIVO_ORIENTADO: 'Microcrédito produtivo orientado',
    CHEQUE_ESPECIAL: 'Cheque especial',
    CONTA_GARANTIDA: 'Conta garantida',
    CAPITAL_GIRO_PRAZO_VENCIMENTO_ATE_365_DIAS: 'Capital de giro (até 365 dias)',
    CAPITAL_GIRO_PRAZO_VENCIMENTO_SUPERIOR_365_DIAS: 'Capital de giro (acima de 365 dias)',
    CAPITAL_GIRO_ROTATIVO: 'Capital de giro rotativo',
    OTHER: 'Outros',
  },
  amortization: {
    SAC: 'SAC',
    PRICE: 'Price',
    SAM: 'SAM',
    SEM_SISTEMA_AMORTIZACAO: 'Sem sistema de amortização',
    OUTROS_AMORTIZACAO: 'Outros',
  },
  periodicity: {
    MONTHLY: 'Mensal',
    BIMONTHLY: 'Bimestral',
    QUARTERLY: 'Trimestral',
    SEMIANNUAL: 'Semestral',
    ANNUAL: 'Anual',
    WITHOUT_PERIODICITY: 'Sem periodicidade',
    OTHERS: 'Outros',
  },
  detail: {
    backToLoans: 'Voltar aos empréstimos',
    contractData: 'Dados do contrato',
    installments: 'Parcelas',
    outstanding: 'Saldo devedor',
    interestRates: 'Taxas de juros',
    contractedFees: 'Tarifas contratadas',
    warranties: 'Garantias',
    paymentHistory: 'Histórico de pagamentos',
    fields: {
      contractDate: 'Data do contrato',
      contractAmount: 'Valor contratado',
      dueDate: 'Vencimento',
      cet: 'CET a.a.',
      amortization: 'Amortização',
      periodicity: 'Periodicidade',
      total: 'Total',
      paid: 'Pagas',
      due: 'A vencer',
      overdue: 'Vencidas',
      paidDate: 'Data do pagamento',
      paidAmount: 'Valor pago',
    },
    table: {
      taxType: 'Tipo de taxa',
      interestRateType: 'Tipo de juros',
      preFixed: 'Pré-fixado',
      postFixed: 'Pós-fixado',
      feeName: 'Nome',
      feeCode: 'Código',
      feeAmount: 'Valor',
      warrantyType: 'Tipo',
      warrantySubtype: 'Subtipo',
      warrantyAmount: 'Valor',
    },
    noPayments: 'Nenhum pagamento sincronizado.',
    noTableData: 'Sem dados para exibir.',
  },
};

export const loansEn = {
  missingLoanId: 'Loan identifier is missing.',
  title: 'Loans',
  description: 'Credit contracts synced via Open Finance.',
  empty: 'No loans found. Connect accounts under Integrations to sync.',
  connectAccounts: 'Go to Integrations',
  hideValues: 'Hide values',
  showValues: 'Show values',
  filters: {
    entity: 'Entity',
    connection: 'Connection',
    all: 'All',
    clearFilters: 'Clear filters',
    noResultsHint: 'Clear filters to see all contracts.',
  },
  summary: {
    totalContracts: 'Contracts',
    totalOutstanding: 'Total outstanding balance',
    activeContracts: 'Active',
    overdueContracts: 'With overdue installments',
  },
  groupedByType: 'By product type',
  typeOther: 'Other',
  card: {
    contract: 'Contract',
    amount: 'Contract amount',
    balance: 'Outstanding balance',
    due: 'Due date',
    cet: 'APR (CET)',
    status: 'Status',
  },
  status: {
    ACTIVE: 'Active',
    PENDING: 'Pending',
    CLOSED: 'Closed',
  },
  types: {
    CREDITO_PESSOAL_SEM_CONSIGNACAO: 'Personal credit (no payroll deduction)',
    CREDITO_PESSOAL_COM_CONSIGNACAO: 'Personal credit (payroll deduction)',
    HOME_EQUITY: 'Home equity',
    MICROCREDITO_PRODUTIVO_ORIENTADO: 'Oriented productive microcredit',
    CHEQUE_ESPECIAL: 'Overdraft',
    CONTA_GARANTIDA: 'Secured account',
    CAPITAL_GIRO_PRAZO_VENCIMENTO_ATE_365_DIAS: 'Working capital (up to 365 days)',
    CAPITAL_GIRO_PRAZO_VENCIMENTO_SUPERIOR_365_DIAS: 'Working capital (over 365 days)',
    CAPITAL_GIRO_ROTATIVO: 'Revolving working capital',
    OTHER: 'Other',
  },
  amortization: {
    SAC: 'SAC',
    PRICE: 'Price',
    SAM: 'SAM',
    SEM_SISTEMA_AMORTIZACAO: 'No amortization system',
    OUTROS_AMORTIZACAO: 'Other',
  },
  periodicity: {
    MONTHLY: 'Monthly',
    BIMONTHLY: 'Bimonthly',
    QUARTERLY: 'Quarterly',
    SEMIANNUAL: 'Semiannual',
    ANNUAL: 'Annual',
    WITHOUT_PERIODICITY: 'No periodicity',
    OTHERS: 'Other',
  },
  detail: {
    backToLoans: 'Back to loans',
    contractData: 'Contract data',
    installments: 'Installments',
    outstanding: 'Outstanding balance',
    interestRates: 'Interest rates',
    contractedFees: 'Contracted fees',
    warranties: 'Collateral',
    paymentHistory: 'Payment history',
    fields: {
      contractDate: 'Contract date',
      contractAmount: 'Contract amount',
      dueDate: 'Due date',
      cet: 'APR (CET)',
      amortization: 'Amortization',
      periodicity: 'Installment frequency',
      total: 'Total',
      paid: 'Paid',
      due: 'Due',
      overdue: 'Overdue',
      paidDate: 'Payment date',
      paidAmount: 'Amount paid',
    },
    table: {
      taxType: 'Tax type',
      interestRateType: 'Interest type',
      preFixed: 'Pre-fixed',
      postFixed: 'Post-fixed',
      feeName: 'Name',
      feeCode: 'Code',
      feeAmount: 'Amount',
      warrantyType: 'Type',
      warrantySubtype: 'Subtype',
      warrantyAmount: 'Amount',
    },
    noPayments: 'No payments synced.',
    noTableData: 'No data to display.',
  },
};
